import { render } from "./monthlyprice.vue?vue&type=template&id=4acc85dc&scoped=true"
import script from "./monthlyprice.vue?vue&type=script&lang=js"
export * from "./monthlyprice.vue?vue&type=script&lang=js"

import "./monthlyprice.vue?vue&type=style&index=0&id=4acc85dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4acc85dc"

export default script